import { AmenityGroup } from '@apps/gated-2021/estimator';

export { pattern } from '@lib/regex';

export const Amenity = {
    groups: {
        houseFeatures: {
            label: 'House Features',
            keys: ['has_waterfront', 'has_community_hot_tub', 'has_community_pool', 'has_private_pool', 'has_private_hot_tub','has_ski_in_ski_out'],
        },
        location: {
            label: 'Location',
            keys: [],
        },
    } as Record<string, AmenityGroup>,
};

export const AmenityLabel = {
    has_waterfront: 'Waterfront',
    has_private_pool: 'Private Swimming Pool',
    has_private_hot_tub: 'Private Hot Tub',
    has_community_pool: 'Community Swimming Pool',
    has_community_hot_tub: 'Community Hot Tub',
    has_ski_in_ski_out: 'Ski-In/Ski-Out',
};
